import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, Inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { AppState } from 'src/app/shareModule/states/app.state';
import { ChatbotService } from 'src/app/shareModule/component/chat/chatbot/chatbot.service';
import { loadUser } from 'src/app/shareModule/states/user-details';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from 'src/app/shareModule/services/customer.service';

@Component({
  selector: 'app-advanced-settings-chat',
  templateUrl: './advanced-settings-chat.component.html',
  styleUrls: [
    './advanced-settings-chat.component.scss',
    '../advanced-settings.component.scss'
  ],
})
export class AdvancedSettingsChatComponent implements OnInit {

  public userInfo: any;
  public blocks: any[] = [];

  public isBotInfoLoading: boolean = false;
  public isBotRegisterationError: boolean = false;
  public isBotBeingEdited: boolean = false;
  public registeredBotToken?: string | null = null;
  public registeredBotUsername?: string | null = null;

  public telegramUserId?: string | null = null;
  public telegramUserFullName?: string | null = null;
  public telegramUsername?: string | null = null;

  public isTelegramUserError: boolean = false;
  public registerationUUID: string = '';

  public candidateBotToken: string = '';

  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private chatbotService: ChatbotService,
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private toastr: ToastrService,
    private customerService: CustomerService,
    @Inject('WINDOW') private window
  ) {
    this.chatbotService.blockeUsers.subscribe((data) => {
      this.blocks = data;
    });


  }

  ngOnInit(): void {

    this.store.pipe(select(selectUser)).subscribe((response: any) => {
      try {
        if (response) {
          const data = response;

          this.userInfo = {
            isVerified: data.isVerified,
            phone: data.phone,
            isEmailVerify: data.isEmailVerify,
            level: data.level,
            allowBookDriver: data.allowBookDriver,
          };

          this.cdr.detectChanges();
        }
      } catch (error) {
        console.log("error", error, "PROFILE")
      }
    });
  }

  ngAfterViewInit(): void {
    this.store.dispatch(loadUser({}))
  }

  public getTelegramLinks() {
    if (this.userInfo?.isTelegramVerified) {
      return;
    }

    this.auth.get_telegram_verification_link().subscribe((e: any) => {
      this.window.open(`${e.telegramLink}`, '_blank');
    });
  }

  public openTelegramPhoneConfirmation() {
    if (this.userInfo.isVerified) {
      this.local.confirmYesNo({
        title: 'Telegram phone verification',
        text: 'Do you have an active telegram that uses the same number as your whatsapp',
        icon: 'success'
      }).then(
        rv => {
          if (rv.isConfirmed) {
            this.auth.verifyAppUserPhone().subscribe({
              next: () => {
                this.toastr.success("Registered!")
                this.store.dispatch(loadUser({}));
              },
              error: (err) => {
                console.error(err)
                this.toastr.error("Error something went wrong please try again")
              }
            })
          }
        }
      )
    } else {
      this.local.alertInfo({
        message: "Please verify whatsapp first"
      })
    }
  }

  public getBitTelegramRegisteration() {
    this.isBotInfoLoading = true;
    this.customerService.getTgBotRegistration().subscribe({
      next: (rv: any) => {
        this.isBotInfoLoading = false;

        if (!rv.ok) {
          this.isBotRegisterationError = true;
          return;
        }
        this.registeredBotToken = rv?.data?.tgToken;
        this.registeredBotUsername = rv?.bot?.username;
        this.isTelegramUserError = rv?.isUserError;
        if (!rv?.isUserError && rv?.telegramUser) {
          this.telegramUserId = rv?.telegramUser?.id + '';
          this.telegramUsername = rv?.telegramUser?.username;
          this.telegramUserFullName = `${rv?.telegramUser?.first_name ?? ' '} ${rv?.telegramUser?.last_name ?? ' '
            }`;
        }
        this.registerationUUID = rv?.data?.linkUUId;
      },
      error: (err) => {
        console.error(err);
        this.isBotInfoLoading = false;
      },
    });
  }

  public updateTelegramBotRegisteration() {
    this.customerService.registerTgBot(this.candidateBotToken).subscribe({
      next: (rv: any) => {
        this.toastr.show('Registeration successful!');
        this.getBitTelegramRegisteration();
        this.isBotBeingEdited = false;
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Error while loading. pleast try again latter');
        this.isBotBeingEdited = false;
      },
    });
  }

  public openRegistration() {
    this.window.open(
      `https://t.me/${this.registeredBotUsername}?start=reg-${this.registerationUUID}`,
      '_blank'
    );
    setTimeout(() => {
      this.getBitTelegramRegisteration();
    }, 10000);
  }

  public unblock(id) {
    this.chatbotService.unBlockUser(id);
  }

}
